import React from 'react';
import { Box, Spacer, Input, InputLabel as Label, Text, theme } from '../..';
import { InputFieldProps } from './InputFieldProps';

export default function InputField(props: InputFieldProps): React.ReactElement {
  const {
    dmId = 'dm-input-field-props',
    id,
    type,
    disabled,
    invalid,
    required,
    reference,
    label,
    style,
    error,
    hint,
    ...otherProps
  } = props;
  const uniqueId = `${id || dmId}-input`; // todo: dmId should be removed, as soon as id prop is required (myt-7757)
  const errorId = `${id || dmId}-input-error`;

  return (
    <Box data-designsystem dmId={`${dmId}-container`}>
      <Label
        htmlFor={uniqueId}
        id={`${id}-label`}
        dmId={`${dmId}-label`}
        required={required}
        disabled={disabled}
        style={{ alignSelf: 'flex-start' }}>
        {`${label}`}
      </Label>
      {hint && (
        <Text
          style={{
            color: theme.palette.color10.hex,
            fontSize: theme.typography.fontSize.s.rem,
          }}>
          {hint}
        </Text>
      )}
      <Spacer size={`${theme.dimension.spacing.xxxs.value}rem`} />
      <Input
        dmId={`${dmId}-input`}
        id={uniqueId}
        required={required}
        disabled={disabled}
        invalid={invalid}
        reference={reference}
        type={type}
        aria-describedby={error && invalid ? errorId : undefined}
        {...otherProps}
      />
      {error && invalid && (
        <Text
          dmId={`${dmId}-error-text`}
          id={errorId}
          kind="error"
          style={style && style.error}>
          {error || ''}
        </Text>
      )}
    </Box>
  );
}
